module.exports = __webpack_public_path__ + "static/media/OM.16c586f7.svg";